const fileFontIcon = `
<svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>font-upload</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--Greenscreen---edit" transform="translate(-637.000000, -686.000000)">
            <g id="greenscreen" transform="translate(309.000000, 481.000000)">
                <g id="Group-11" transform="translate(26.000000, 88.000000)">
                    <g id="font-upload" transform="translate(302.000000, 117.000000)">
                        <g id="Outline_Icons" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Group" transform="translate(3.000000, 9.000000)">
                                <polyline id="Path" points="8.65529167 11.1041667 4.863625 0 1.08333333 11.1041667"></polyline>
                                <line x1="2.374125" y1="7.3125" x2="7.36125" y2="7.3125" id="Path"></line>
                                <line x1="0.270833333" y1="11.1041667" x2="1.90720833" y2="11.1041667" id="Path"></line>
                                <line x1="7.84279167" y1="11.1041667" x2="9.47916667" y2="11.1041667" id="Path"></line>
                                <polyline id="Path" points="12.1880417 11.1041667 9.69745833 3.810625 8.419125 7.56545833"></polyline>
                                <line x1="9.165" y1="8.39583333" x2="11.2634167" y2="8.39583333" id="Path"></line>
                                <line x1="11.6545" y1="11.1041667" x2="12.7291667" y2="11.1041667" id="Path"></line>
                            </g>
                            <g id="Group">
                                <polygon id="Path" points="19.5 23.5 0.5 23.5 0.5 0.5 13.5 0.5 19.5 6.5"></polygon>
                                <polyline id="Path" points="13.5 0.5 13.5 6.5 19.5 6.5"></polyline>
                            </g>
                        </g>
                        <g id="Invisible_Shape">
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>

    `;

export default fileFontIcon;
